const TRACKING_ID = "G-MF0R5QESBS";
const EXCLUDED_PATHS = ["/404"];
const INTERACTION_EVENTS = ["pointerdown", "keydown", "scroll", "touchstart"];
const FALLBACK_DELAY = 5000;

let loaded = false;

const doNotTrack = () =>
  navigator.doNotTrack === "1" || window.doNotTrack === "1" || navigator.msDoNotTrack === "1";

const isExcluded = () =>
  EXCLUDED_PATHS.some((path) => window.location.pathname.startsWith(path));

const loadGtag = () => {
  if (loaded) return;
  loaded = true;
  INTERACTION_EVENTS.forEach((e) => window.removeEventListener(e, loadGtag));

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", TRACKING_ID, {
    anonymize_ip: true,
    cookie_expires: 0,
    send_page_view: !isExcluded(),
  });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${TRACKING_ID}`;
  document.head.appendChild(script);
};

// Load analytics after first interaction (or a timeout), not during page load.
export const onClientEntry = () => {
  if (process.env.NODE_ENV !== "production" || doNotTrack()) return;
  INTERACTION_EVENTS.forEach((e) => window.addEventListener(e, loadGtag, { once: true, passive: true }));
  setTimeout(loadGtag, FALLBACK_DELAY);
};

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (!prevLocation || typeof window.gtag !== "function" || isExcluded()) return;
  window.gtag("event", "page_view", {
    page_path: location.pathname + location.search + location.hash,
  });
};
